module.exports = __webpack_public_path__ + "img/islington_side_ext_b1.7faccb1f.jpg";